<template>
  <div id="videoplaycnt">
    <div class="popoverlayBg" v-if="popoverlayBg"></div>
    <div class="videoOuter">
      <div class="video-player-box">
        <span class="closeModel" @click="videoCloseModel()">X</span>
        <vue-plyr ref="plyr">
          <video poster="poster.png" :src="this.v_link" id="player">
            <source :src="this.v_link" type="video/mp4" size="1080" />
          </video>
        </vue-plyr>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "VideoModel",

  data() {
    return {
      popoverlayBg: true
    };
  },

  mounted() {
    this.$refs.plyr.player.play();
  },

  computed: {},
  props: {
    v_link: null
  },

  methods: {
    videoCloseModel() {
      this.isVideo = false;
      document.body.classList.remove("videoBody");
      this.$refs.plyr.player.stop();
    }
  }
};
</script>

<style scoped>
.videoOuter {
  position:fixed;
  width: 100%;
  height: 100%;
  left: 0%;
  top: 0%;
  z-index: 11111;
  background: transparent;
  display: none;
   

}
.videoBody .popoverlayBg {
  display: block;
  z-index: 1111;
}

.videoBody .videoOuter {
  display: block;
}

.video-player-box {
  width: 95%;
  height: auto;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1111;
  padding: 5px;
  transform: translate(-50%, -50%);
  border-radius: 5px;
}

#videoplaycnt video {
  /* max-width: 100vw;
  height: 100vh; */
}

.video-player-box .closeModel {
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0);
  display: inline-block;
  position: absolute;
  left: auto;
  right: -5px;
  z-index: 1;
  border-radius: 5px;
  top: -10px;
  color: #fff;
  line-height: 32px;
  font-weight: bold;
  text-align: center;
}
.popoverlayBg {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 11;
  background: rgba(0, 0, 0, 0.7);
  left: 0;
  top: 0;
  display: none;
}
@media only screen and (min-width: 768px){

 .video-player-box{
width: 29%;
 }

}
</style>